export default "__VITE_ASSET__e7c96bed__"